import { useStytch } from '@stytch/nextjs';
import { useCallback, useRef, useState } from 'react';

import theraToast from 'components/generic-components/toast/TheraToast';
import { AuthRoutes } from 'routes';

export const useStytchVerifyEmail = ({
  onSuccess,
}: {
  onSuccess?: () => void;
}): {
  sendVerificationEmail: (emailAddress: string) => Promise<void>;
  isSending: boolean;
} => {
  const [isSending, setIsSending] = useState(false);
  // State lags a render behind, so two calls in the same render would both see isSending as false.
  const isSendingRef = useRef(false);
  const stytch = useStytch();

  const sendVerificationEmail = useCallback(
    async (emailAddress: string) => {
      if (!emailAddress || isSendingRef.current) return;
      isSendingRef.current = true;
      setIsSending(true);
      try {
        const response = await stytch.magicLinks.email.send(emailAddress, {
          login_magic_link_url:
            window.location.origin + AuthRoutes.Authenticate + '?email=' + encodeURIComponent(emailAddress),
          login_expiration_minutes: 60 * 24 * 7,
          login_template_id: 'email_verification',
        });
        console.info('Verification Email sent!', response);
        onSuccess?.();
      } catch (reason) {
        theraToast.error({
          message: 'Failed to send email verification link',
          error: reason,
          options: {
            id: 'email-sending-failed',
          },
        });
      } finally {
        isSendingRef.current = false;
        setIsSending(false);
      }
    },
    [onSuccess, stytch],
  );

  return {
    sendVerificationEmail,
    isSending,
  };
};

export default useStytchVerifyEmail;
